import { JobListingType } from 'src/graphql/types/jobListings'

import OfficeApplicationTab from '../OfficeApplicationTab/OfficeApplicationTab'

import ApplicationTab from './ApplicationTab'

interface ApplicationTabWrapperProps {
  applicantId: string
  applicantInfo: any
  onRender: any
  onApplicantNotFound: () => void
}

const ApplicationTabWrapper = ({
  applicantId,
  applicantInfo,
  onRender,
  onApplicantNotFound,
}: ApplicationTabWrapperProps) => {
  const jobListingType = applicantInfo?.jobListing?.type || null
  const isOfficeApplication = jobListingType === JobListingType.OFFICE

  // Render OfficeApplicationTab for office job listings (admin only)
  if (isOfficeApplication) {
    return (
      <OfficeApplicationTab
        applicantId={applicantId}
        onRender={onRender}
        onApplicantNotFound={onApplicantNotFound}
      />
    )
  }

  // Default to regular ApplicationTab
  return (
    <ApplicationTab
      applicantId={applicantId}
      onRender={onRender}
      onApplicantNotFound={onApplicantNotFound}
    />
  )
}

export default ApplicationTabWrapper
